import Navbar from './Navbar';
import Footer from './Footer';
import PageHero from './PageHero';
import ProductCard from './ProductCard';
import Formular from './Formular';
import { ScrollRestoration } from 'react-router-dom';
import strkopiesky04 from '../resources/Štrkopiesok 0-4.jpeg';
import strkopiesky016 from '../resources/Štrkopiesok 0-16.jpeg';
import strkopiesky48 from '../resources/Štrkopiesok 4-8.jpeg';
import strkopiesky816 from '../resources/Štrkopiesok 8-16.jpeg';

const items = [
    'Frakcia 0/4 Štrkopiesky',
    'Frakcia 4/8 Štrkopiesky',
    'Frakcia 0/16 Štrkopiesky',
    'Frakcia 8/16 Štrkopiesky',
];

const cards = [
    {
        img: strkopiesky04,
        badge: 'Ťažené riečne kamenivo',
        title: 'Frakcia 0/4',
        description: 'Vhodný ako podkladová vrstva pod exteriérovú dlažbu, zhutňujúca vrstva, na obsypanie vodovodných a kanalizačných potrubí.',
        tableRows: [{ label: 'Cena za t', bezDph: '20,33 €', sDph: '25,00 €' }],
    },
    {
        img: strkopiesky48,
        badge: 'Ťažené riečne kamenivo',
        title: 'Frakcia 4/8',
        description: 'Triedený, praný štrk vhodný ako dekoratívny, vhodný ako prímes pre špeciálne betóny, obsypy drenáže.',
        tableRows: [{ label: 'Cena za t', bezDph: '21,79 €', sDph: '26,80 €' }],
    },
    {
        img: strkopiesky016,
        badge: 'Ťažené riečne kamenivo',
        title: 'Frakcia 0/16',
        description: 'Betonársky štrk - vhodný na všeobecnú betonáž základov, prekladov, stropných dosiek, výrobu betónových výrobkov.',
        tableRows: [{ label: 'Cena za t', bezDph: '21,30 €', sDph: '26,20 €' }],
    },
    {
        img: strkopiesky816,
        badge: 'Ťažené riečne kamenivo',
        title: 'Frakcia 8/16',
        description: 'Dekoratívny triedený a praný štrk, vhodný na voľné plochy, zásyp na ploché strechy, zásypy drenáží a základov.',
        tableRows: [{ label: 'Cena za t', bezDph: '22,03 €', sDph: '27,10 €' }],
    },
];

function Strkopiesky() {
    return (
        <div>
            <Navbar />
            <PageHero
                title="Naša"
                highlight="ponuka"
                subtitle="Štrkopiesky – ťažené riečne kamenivo najvyššej kvality."
            />
            <div className="max-w-screen-xl mx-auto px-6 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {cards.map((card, i) => (
                    <ProductCard key={i} {...card} />
                ))}
            </div>
            <Formular napln={items} />
            <Footer />
            <ScrollRestoration />
        </div>
    );
}

export default Strkopiesky;
